import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export const GenericError = ({ message }: { message: string }) => {
  const { t } = useTranslation();
  return (
    <div data-testid="general-error" className="flex flex-col gap-4">
      <strong>{t("title_purchase.error.generic.title")}</strong>
      <p>{message}</p>
    </div>
  );
};
